/**
 * @render react
 * @name Text
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

/**
 * Text component
 *
 * @param {Object} props - the props object
 * @param {string} props.content - Content to be outputted
 * @param {Node} props.children - nested components
 * @param {boolean} props.span - Wrap text between span tags
 * @param {boolean} props.loadStyles - Whether to apply the class names for styling
 * @param {Object} props.extraClassNames - Extra class names to be applied to the component
 * @param {Object} props.context - Extra information coming from Polaris provider.
 */
const Text = (
  {
    content,
    children,
    span,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  },
) => {
  if (span) {
    return (
      <span
        className={classNames({
          [`${cssPrefix}__text`]: loadStyles,
          ...extraClassNames,
        })}
      >
        {content}
        {children}
      </span>
    );
  }
  return content || children;
};

/**
 * Valid props
 */
Text.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node,
  span: PropTypes.bool,
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
  context: PropTypes.shape(),
};

/**
 * Default props
 */
Text.defaultProps = {
  content: '',
  children: [],
  span: true,
  loadStyles: true,
  extraClassNames: {},
  context: {},
};

export default withPolaris(Text);
